module.exports = __webpack_public_path__ + "static/media/catalog.8be8b833.svg";